var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhXBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5766 29.9235C32.9289 30.2757 33.1267 30.7534 33.1267 31.2516C33.1267 31.7497 32.9289 32.2275 32.5766 32.5797C32.2244 32.932 31.7466 33.1298 31.2485 33.1298C30.7503 33.1298 30.2726 32.932 29.9204 32.5797L20.0001 22.6563L10.0766 32.5766C9.72438 32.9288 9.24664 33.1267 8.74849 33.1267C8.25035 33.1267 7.77261 32.9288 7.42037 32.5766C7.06813 32.2243 6.87024 31.7466 6.87024 31.2485C6.87024 30.7503 7.06813 30.2726 7.42037 29.9203L17.3438 20L7.42349 10.0766C7.07125 9.72435 6.87336 9.24661 6.87336 8.74847C6.87336 8.25032 7.07125 7.77258 7.42349 7.42034C7.77573 7.0681 8.25347 6.87021 8.75162 6.87021C9.24976 6.87021 9.7275 7.0681 10.0797 7.42034L20.0001 17.3438L29.9235 7.41878C30.2757 7.06654 30.7535 6.86865 31.2516 6.86865C31.7498 6.86865 32.2275 7.06654 32.5797 7.41878C32.932 7.77102 33.1299 8.24876 33.1299 8.7469C33.1299 9.24505 32.932 9.72279 32.5797 10.075L22.6563 20L32.5766 29.9235Z",
    fill: "#3E3B3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhXBold);
export default __webpack_public_path__ + "static/media/ph_x-bold.f19dca9f589e4434eae75e710688c4a5.svg";
export { ForwardRef as ReactComponent };